export default "__VITE_ASSET__3eZOJXX7__"